import { DataFetchingThunkAction } from '../types';
import { getErrorCustomData } from '../../../common/errors/CustomFetchApiError';
import {
    FETCH_SEARCH_SUGGESTIONS,
    CLEAR_SEARCH_SUGGESTIONS,
    FETCH_SEARCH_SUGGESTIONS_SUCCESS,
    FETCH_SEARCH_SUGGESTIONS_FAILED,
    FETCH_SEARCH_REDIRECT_SUCCESS,
    FETCH_SEARCH_REDIRECT,
    FETCH_SEARCH_REDIRECT_FAIL,
    FetchSearchSuggestionsAction,
    ClearSearchSuggestionsAction,
    FetchSearchSuggestionsSuccessAction,
    FetchSearchRedirectSuccessAction,
    FetchSearchRedirectsAction,
    FetchSearchSuggestionsFailedAction,
    SearchSuggestionResponse,
    SearchRedirectsResponse,
    FetchSearchRedirectFailedAction,
    SetQueryAction,
    SET_QUERY,
} from './types';

export const isFetchingSearchSuggestionAction = (): FetchSearchSuggestionsAction => ({
    type: FETCH_SEARCH_SUGGESTIONS,
});

export const fetchSearchSuggestionSuccessAction = (
    response: SearchSuggestionResponse
): FetchSearchSuggestionsSuccessAction => ({
    type: FETCH_SEARCH_SUGGESTIONS_SUCCESS,
    payload: response,
});

export const fetchSearchSuggestionFailedAction = (error: Error): FetchSearchSuggestionsFailedAction => ({
    type: FETCH_SEARCH_SUGGESTIONS_FAILED,
    payload: error,
});

export const clearSearchSuggestionAction = (exemptQuery?: boolean): ClearSearchSuggestionsAction => ({
    type: CLEAR_SEARCH_SUGGESTIONS,
    payload: { exemptQuery },
});

export const fetchSearchSuggestionAction = (): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    const { query } = getState().searchSuggestion;
    if (!query) {
        return;
    }
    dispatch(isFetchingSearchSuggestionAction());
    try {
        const searchSuggestionResponse = await apiService.shopApi.getSearchSuggestions(query);
        if (query !== getState().searchSuggestion.query) {
            return;
        }
        dispatch(fetchSearchSuggestionSuccessAction(searchSuggestionResponse));
    } catch (err) {
        logger.error(err, { action: 'fetchSearchSuggestionFailedAction', ...getErrorCustomData(err) });
        dispatch(fetchSearchSuggestionFailedAction(err));
    }
};

export const isFetchingSearchRedirectAction = (): FetchSearchRedirectsAction => ({
    type: FETCH_SEARCH_REDIRECT,
});

export const fetchSearchRedirectSuccessAction = (
    response: SearchRedirectsResponse
): FetchSearchRedirectSuccessAction => ({
    type: FETCH_SEARCH_REDIRECT_SUCCESS,
    payload: response,
});

export const fetchSearchRedirectFailedAction = (error: Error): FetchSearchRedirectFailedAction => ({
    type: FETCH_SEARCH_REDIRECT_FAIL,
    payload: error,
});

export const setQueryAction = (query: string): SetQueryAction => ({
    type: SET_QUERY,
    payload: { query },
});

export const fetchSearchRedirectsIfNeeded = (search?: string): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    const { query } = getState().searchSuggestion;
    const searchParam = query || search;
    if (!searchParam) {
        return;
    }
    dispatch(isFetchingSearchRedirectAction());
    try {
        const searchRedirectResponse = await apiService.shopApi.getSearchRedirects(searchParam);
        if (query !== getState().searchSuggestion.query) {
            return;
        }
        dispatch(fetchSearchRedirectSuccessAction(searchRedirectResponse));
    } catch (err) {
        logger.error(err, { action: 'fetchSearchRedirectFailedAction', ...getErrorCustomData(err) });
        dispatch(fetchSearchRedirectFailedAction(err));
    }
};
